import React from 'react';
import { FormattedMessageWrappedInSpan } from '../../../components/misc';

const JobFinance = ({setShowJob, showJob, job, ...props}) => {

  return (
    <>
    { job == "finance" &&
    <div className="container-960 container-page">
      <h2>
        <FormattedMessageWrappedInSpan id="jobsPage.finance.headline" defaultMessage="Placeholder" />
      </h2>
      <br />
      <br />
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.finance.aboutus.title" defaultMessage="Placeholder" />
      </b>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.finance.aboutus.text1"
          defaultMessage="Placeholder"
          values={{
            br: <br />,
          }}
        />
      </p>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.finance.aboutus.text2"
          defaultMessage="Placeholder"
          values={{
            br: <br />,
          }}
        />
      </p>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.finance.aboutus.text3"
          defaultMessage="Placeholder"
          values={{
            br: <br />,
          }}
        />
      </p>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet1" defaultMessage="Placeholder" />
            <ul>
              <li>
                <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet1-1" defaultMessage="Placeholder" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet1-2" defaultMessage="Placeholder" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet1-3" defaultMessage="Placeholder" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet1-4" defaultMessage="Placeholder" />
              </li>
              <li>
                <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet1-5" defaultMessage="Placeholder" />
              </li>
            </ul>
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet4" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet5" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet6" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.yourroll.bullet7" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet4" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet5" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet6" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet7" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet8" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet9" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet10" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.needs.bullet11" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.title" defaultMessage="Placeholder" />
      </b>
      <span>
        <ul>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet1" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet2" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet3" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet4" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet5" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet6" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet7" defaultMessage="Placeholder" />
          </li>
          <li>
            <FormattedMessageWrappedInSpan id="jobsPage.finance.offer.bullet8" defaultMessage="Placeholder" />
          </li>
        </ul>
      </span>
      <b>
        <FormattedMessageWrappedInSpan id="jobsPage.finance.contact.title" defaultMessage="Placeholder" />
      </b>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.finance.contact.intro"
          defaultMessage="Placeholder"
        />
      </p>
      <p>
        <FormattedMessageWrappedInSpan
          id="jobsPage.finance.contact.contact"
          defaultMessage="Placeholder"
        />
      </p>
      <br />
      <button className="secondary" onClick={() => setShowJob(!showJob)}>
        <FormattedMessageWrappedInSpan
          id="jobsPage.back"
          defaultMessage="back"
        />
      </button>
      </div>
            }
      </>
  )
}

export default JobFinance
